module.exports = __webpack_public_path__ + "static/media/bookingicon.41602c13.svg";